import { connect } from 'react-redux';
import { requestEarningsCalculation } from './redux/actionCreators';
import { getEarningsCalculatorState } from './redux/selectors';
const mapStateToProps = (state)=>{
    const earningsState = getEarningsCalculatorState(state);
    return {
        estimatedEarningsResponse: earningsState.result
    };
};
const mapDispatchToProps = {
    requestEarningsCalculation
};
export default connect(mapStateToProps, mapDispatchToProps);
